// extracted by mini-css-extract-plugin
export default {"container":"NumberGraph_container__0CNe-","vl":"NumberGraph_vl__8JQEp","hl":"NumberGraph_hl__jY10b"};